import React, { useEffect } from 'react'
import './App.css'
import { RouterProvider } from 'react-router-dom'
import router from './router/router'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { themeOptions } from 'theme'
import { AuthProvider } from 'contexts/AuthContext'
import { Toaster, toast } from 'react-hot-toast' // <-- NEW: Import Toaster and toast
import axios from 'axios' // <-- NEW: Import axios

const theme = createTheme(themeOptions)

function App() {
  // --- NEW: Axios interceptor for global error handling ---
  useEffect(() => {
    const errorInterceptor = axios.interceptors.response.use(
      (response) => response, // Pass through successful responses
      (error) => {
        // Handle server-side errors
        if (error.response) {
          // Extract a user-friendly message from the server's response
          const message =
            error.response.data?.message ||
            `Erreur ${error.response.status}: Une erreur inattendue est survenue.`

          // We exclude 401 errors because the AuthContext already handles them
          // by logging the user out. Showing a toast here would be redundant.
          if (error.response.status !== 401) {
            toast.error(message, {
              duration: 5000, // Make toast last 5 seconds
              position: 'top-right',
            })
          }
        } else if (error.request) {
          // Handle network errors (request made but no response received)
          toast.error('Erreur de connexion. Impossible de joindre le serveur.')
        }

        // IMPORTANT: This forwards the error, so that individual component
        // .catch() blocks can still run for component-specific logic.
        return Promise.reject(error)
      }
    )

    // Cleanup function to remove the interceptor when the app unmounts
    return () => {
      axios.interceptors.response.eject(errorInterceptor)
    }
  }, []) // The empty dependency array ensures this effect runs only once

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        {/* --- NEW: Add the Toaster component to render notifications --- */}
        <Toaster />
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ThemeProvider>
    </LocalizationProvider>
  )
}

export default App
